<template>
  <Teleport to="body">
    <Transition name="modal">
      <div
          v-if="isOpen"
          class="fixed inset-0 z-50 flex items-center justify-center"
          @click="handleBackdropClick"
      >
        <!-- Backdrop -->
        <div class="absolute inset-0 bg-black bg-opacity-50"></div>

        <!-- Modal Content -->
        <div
            class="relative bg-white rounded-lg shadow-xl max-w-md w-full mx-4 max-h-[90vh] overflow-hidden"
            @click.stop
        >
          <!-- Header -->
          <div v-if="title || $slots.header" class="p-5">
            <slot name="header">
              <div class="flex items-center justify-between">
                <h3 class="uppercase text-[11px] text-[#788087] font-semibold leading-none tracking-[2%]">{{ title }}</h3>
                <button
                    v-if="showCloseButton"
                    @click="close"
                    class="text-gray-400 hover:text-gray-600 transition-colors"
                >
                  <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                  </svg>
                </button>
              </div>
            </slot>
          </div>

          <!-- Body -->
          <div class="px-5 pb-5 overflow-y-auto">
            <slot></slot>
          </div>

        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup lang="ts">
interface Props {
  isOpen: boolean;
  title?: string;
  showCloseButton?: boolean;
  closeOnBackdrop?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  showCloseButton: true,
  closeOnBackdrop: true,
});

const emit = defineEmits<{
  close: [];
}>();

const close = () => {
  emit('close');
};

const handleBackdropClick = () => {
  if (props.closeOnBackdrop) {
    close();
  }
};

// Заблокувати скрол body коли модальне вікно відкрите
watch(() => props.isOpen, (isOpen) => {
  if (process.client) {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }
});

// Очистити стилі при unmount
onUnmounted(() => {
  if (process.client) {
    document.body.style.overflow = '';
  }
});
</script>

<style scoped>
.modal-enter-active, .modal-leave-active {
  transition: all 0.3s ease;
}

.modal-enter-from, .modal-leave-to {
  opacity: 0;
}

.modal-enter-from .relative,
.modal-leave-to .relative {
  transform: scale(0.95) translateY(-20px);
}
</style>